export { default as MenuIcon } from '@material-ui/icons/Menu';
export { default as MenuUpIcon } from '@material-ui/icons/KeyboardArrowUp';
export { default as LogoutIcon } from '@material-ui/icons/LockOpen';
export { default as ChatIcon } from '@material-ui/icons/Chat';
export { default as VideoChatIcon } from '@material-ui/icons/Videocam';
export { default as TasksIcon } from '@material-ui/icons/CheckBox';
export { default as HomeIcon } from '@material-ui/icons/HomeOutlined';
export { default as MessagesIcon } from '@material-ui/icons/ChatBubbleOutline';
export { default as BackIcon } from '@material-ui/icons/ArrowBack';
export { default as ExpandIcon } from '@material-ui/icons/ExpandMore';
export { default as CollapseIcon } from '@material-ui/icons/ExpandLess';
export { default as UncheckedIcon } from '@material-ui/icons/CheckBoxOutlineBlank';
export { default as CheckedIcon } from '@material-ui/icons/CheckBox';
export { default as SearchIcon } from '@material-ui/icons/Search';
export { default as ClearIcon } from '@material-ui/icons/Clear';
export { default as FaceIcon } from '@material-ui/icons/Face';
export { default as SendIcon } from '@material-ui/icons/Send';
export { default as ChatCollapseIcon } from '@material-ui/icons/KeyboardArrowDown';
export { default as UnreadIcon } from '@material-ui/icons/Star';
export { default as FowardIcon } from '@material-ui/icons/ArrowForwardIosOutlined';
export { default as DoneIcon } from '@material-ui/icons/CheckBox';
export { default as NotDoneIcon } from '@material-ui/icons/CheckBoxOutlineBlank';
export { default as SeparatorIcon } from '@material-ui/icons/KeyboardArrowRight';
export { default as OpenInNewWindowIcon } from '@material-ui/icons/OpenInNew';
export { default as PrevIcon } from '@material-ui/icons/KeyboardArrowLeft';
export { default as NextIcon } from '@material-ui/icons/KeyboardArrowRight';
export { default as CompletedIcon } from '@material-ui/icons/Done';
export { default as CloseIcon } from '@material-ui/icons/Close';
export { default as CorrectIcon } from '@material-ui/icons/Star';
export { default as CorrectMarkerIcon } from '@material-ui/icons/StarBorder';
export { default as IncorrectIcon } from '@material-ui/icons/Clear';
export { default as PersonIcon } from '@material-ui/icons/Person';
export { default as ListIcon } from '@material-ui/icons/List';
export { default as InfoIcon } from '@material-ui/icons/InfoOutlined';
export { default as ContactIcon } from '@material-ui/icons/PermContactCalendar';
export { default as QuestionnaireIcon } from '@material-ui/icons/LiveHelp';
export { default as CompletedQuestionnaireIcon } from '@material-ui/icons/AssignmentTurnedIn';
export { default as PlanIcon } from '@material-ui/icons/Assignment';
export { default as EditIcon } from '@material-ui/icons/Edit';
export { default as CancelIcon } from '@material-ui/icons/Close';
export { default as SaveIcon } from '@material-ui/icons/Save';
export { default as ReadIcon } from '@material-ui/icons/LabelOutlined';
export { default as ReadUnreadIcon } from '@material-ui/icons/Label';
export { default as CalendarIcon } from '@material-ui/icons/DateRange';
export { default as TrainingIcon } from '@material-ui/icons/Assignment';
export { default as VideoIcon } from '@material-ui/icons/PlayCircleFilled';
export { default as UnansweredQuestionnaireIcon } from '@material-ui/icons/AssignmentLate';
export { default as PrintIcon } from '@material-ui/icons/Print';
export { default as FavouritesIcon } from '@material-ui/icons/Star';
export { default as FavouritesUncheckedIcon } from '@material-ui/icons/StarBorder';
export { default as NotesIcon } from '@material-ui/icons/Edit';
export { default as DeleteIcon } from '@material-ui/icons/Delete';
export { default as AddIcon } from '@material-ui/icons/AddCircleOutline';
export { default as LogIcon } from '@material-ui/icons/List';
export { default as CommentIcon } from '@material-ui/icons/Comment';
export { default as TrophyIcon } from '@material-ui/icons/EmojiEvents';
export { default as FoodIcon } from '@material-ui/icons/Restaurant';
export { default as BudskapIcon } from '@material-ui/icons/Beenhere';
export { default as ArticleIcon } from '@material-ui/icons/WebAsset';
export { default as RotateIcon } from '@material-ui/icons/Rotate90DegreesCcw';
export { default as ZoomInIcon } from '@material-ui/icons/ZoomIn';
export { default as ZoomOutIcon } from '@material-ui/icons/ZoomOut';
export { default as AddImageIcon } from '@material-ui/icons/AddAPhoto';
export { default as HelpIcon } from '@material-ui/icons/Help';
export { default as SleepIcon } from '@material-ui/icons/Hotel';
export { default as TimeIcon } from '@material-ui/icons/Schedule';
export { default as ElementListIcon } from '@material-ui/icons/Dns';
export { default as BullsEyeIcon } from '@material-ui/icons/TrackChanges';
export { default as CheckMarkIcon } from '@material-ui/icons/Done';
export { default as CancelOutlinedIcon } from '@material-ui/icons/CancelOutlined';
export { default as NotInterestedIcon } from '@material-ui/icons/NotInterested';
export { default as FeedbackIcon } from '@material-ui/icons/Feedback';
export { default as ThumbUpIcon } from '@material-ui/icons/ThumbUp';
export { default as SunIcon } from '@material-ui/icons/WbSunny';
export { default as AnalyticsIcon } from '@material-ui/icons/InsertChart';
export { default as AlarmIcon } from '@material-ui/icons/AccessAlarm';
export { default as DotIcon } from '@material-ui/icons/Brightness1';
export { default as OrgIcon } from '@material-ui/icons/AccountBalance';
